"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputComponent = void 0;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class InputComponent {
  constructor() {
    _defineProperty(this, "_up", false);
    _defineProperty(this, "_down", false);
    _defineProperty(this, "_left", false);
    _defineProperty(this, "_right", false);
    _defineProperty(this, "_shoot", false);
    this.reset();
  }
  get leftIsDown() {
    return this._left;
  }
  get rightIsDown() {
    return this._right;
  }
  get downIsDown() {
    return this._down;
  }
  get upIsDown() {
    return this._up;
  }
  get shootIsDown() {
    return this._shoot;
  }
  reset() {
    this._up = false;
    this._down = false;
    this._right = false;
    this._left = false;
    this._shoot = false;
  }
  update() {
    // This method should be overridden in subclasses
    throw new Error("Method 'update()' must be implemented.");
  }
  set lockInput(val) {
    // This method should be overridden in subclasses if input locking is needed
    throw new Error("Method 'lockInput' must be implemented.");
  }
}
exports.InputComponent = InputComponent;